export const GOOGLE_SETTINGS = {
  CLIENT_ID: '37646582031-e281jj291amtk805td0hgfqss2jfkdcd.apps.googleusercontent.com',
  API_KEY: 'AIzaSyBqr3r5B5QGb_drLTK8_q9HW7YUez83Bik',
};

export const GOOGLE_DISCOVERY_DOCS = [];
export const GOOGLE_SCOPES = '' +
  ' https://www.googleapis.com/auth/drive.install' +
  ' https://www.googleapis.com/auth/drive';

export const GOOGLE_DEFAULT_FIELDS_FOR_DRIVE = 'id,title,mimeType,md5Checksum,userPermission,editable,modifiedDate,shared,createdDate,fileSize,downloadUrl,exportLinks,webContentLink';

export const DEFAULT_SYNC_FILE_NAME = 'SUPER_PRODUCTIVITY_SYNC.json';
